<template>
  <section class="CompanySettingsUpdateModal">
    <MuiCardAlert
      v-if="ccAlertShow"
      :type="ccAlertType"
      full-width
    >
      <template
        v-if="ssCompanySettingsModuleStatus.UPDATE_IN"
      >
        Please wait, we're updating your Company settings
      </template>

      <template
        v-if="ssCompanySettingsModuleStatus.UPDATE_SUCESS"
      >
        Your company data has been successfully updated!
      </template>

      <template
        v-if="ssCompanySettingsModuleStatus.UPDATE_ERROR"
      >
        Oops. Something went wrong.
      </template>
    </MuiCardAlert>
  </section>
</template>

<script>

import { mapState } from 'vuex';

import { MuiCardAlert } from '@ubeeqo/motion-ui';
import * as CompanySettingsModule from '../CompanySettingsModule';

export default {
  name: 'CompanySettingsUpdateModalComponent',
  components: {
    MuiCardAlert,
  },
  computed: {
    ...mapState(CompanySettingsModule.FULL_NAMESPACE, {
      ssCompanySettingsModuleStatus: s => s.STATUS,
    }),
    ccAlertShow() {
      if (this.ssCompanySettingsModuleStatus.UPDATE_IN
        || this.ssCompanySettingsModuleStatus.UPDATE_SUCESS
        || this.ssCompanySettingsModuleStatus.UPDATE_ERROR) {
        return true;
      }
      return false;
    },
    ccAlertType() {
      if (this.ssCompanySettingsModuleStatus.UPDATE_IN) {
        return 'info';
      }
      if (this.ssCompanySettingsModuleStatus.UPDATE_SUCESS) {
        return 'success';
      }
      if (this.ssCompanySettingsModuleStatus.UPDATE_ERROR) {
        return 'danger';
      }
      return 'info';
    },
  },
};
</script>
